import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/299884e0-ebbe-4c65-9dc7-6bb2e5af9619.png" 
                alt="Lone Pine"
                className="h-10 w-10 object-contain"
              />
              <span className="text-lg font-bold">Lone Pine</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              A transparent community governance platform for Lone Pine HOA members to discuss, share, and shape our community's future.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/forums" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Discussion Forums
                </Link>
              </li>
              <li>
                <Link to="/documents" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Document Library
                </Link>
              </li>
              <li>
                <Link to="/notifications" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Notifications
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/profile" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  User Profile
                </Link>
              </li>
              <li>
                <Link to="/moderation" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Moderation Tools
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  Lone Pine, Montana
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  info@lonepinehoa.org
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  Mountain Time (MST)
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Lone Pine Public Square. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}